import { AnyObject } from 'antd/es/_util/type'

import { PreviewApplicationsLog } from './PreviewApplicationsLog'
import { CommonApplicationsProps, LogApplicationsActionsTypes } from './types'

export const modalsApplicationActions: Record<
  LogApplicationsActionsTypes,
  React.FC<CommonApplicationsProps>
> = {
  preview: PreviewApplicationsLog
}

export const returnRenderValue = (value?: string | AnyObject) => {
  if (!value) return null

  if (typeof value === 'string' || typeof value === 'number') return value

  if (typeof value === 'object')
    return <pre>{JSON.stringify(value, null, 2)}</pre>

  return null
}
